import { useCallback, useEffect, useState } from "react";
import "./App.css";
import Form from "./components/Form";
import { type ThemeId } from "@volvo/vcdk";
import { Modal, Spinner, ThemeProvider, Typography } from "@volvo/vcdk-react";
import LandingPage from "./components/Common/LandingPage/LandingPage";
import {
    verifyToken,
    obtainSessionToken,
    getEnvironmentConfig,
} from "./api/apiService";
import "@volvo/vcdk/themes/volvo/semantic-light.css";
import log from "./logging/logger";
import { UITEXT } from "./constants/const";
import NonProdMessage from "./components/Common/NonProdMessage/NonProdMessage";

function App() {
    const [themeId] = useState<ThemeId>("volvo-light");
    const [isTokenValid, setTokenValid] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isEnvMessageVisible, setEnvMessageVisible] = useState(false);

    const fetchEnvironmentConfig = useCallback(async () => {
        try {
            const environment = await getEnvironmentConfig();
            if (environment !== UITEXT.ProductionEnvironment) {
                setEnvMessageVisible(true);
            }
        } catch (error) {
            log.error("Failed to fetch environment config:", error);
        }
    }, []);

    useEffect(() => {
        fetchEnvironmentConfig();
    }, [fetchEnvironmentConfig]);

    useEffect(() => {
        const token = obtainSessionToken();
        if (token) {
            verifyToken(token)
                .then(() => {
                    setTokenValid(true);
                })
                .catch((error) => {
                    log.error("Token verification failed", error);
                    setTokenValid(false);
                    setErrorMessage(
                        "The link you attempted to access is either invalid or has expired."
                    );
                    setIsOpen(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, []);
    if (isLoading) {
        return (
            <ThemeProvider themeId={themeId}>
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Spinner />
                </div>
            </ThemeProvider>
        );
    }
    return (
        <ThemeProvider themeId={themeId}>
            {isEnvMessageVisible && (
                <NonProdMessage setEnvMessageVisible={setEnvMessageVisible} />
            )}
            <div>{isTokenValid ? <Form /> : <LandingPage />}</div>
            <Modal
                className="Modal"
                open={isOpen}
                onClose={() => setIsOpen(false)}
            >
                <section className="FormSection">
                    <div>
                        <Typography variant="body">{errorMessage}</Typography>
                    </div>
                </section>
            </Modal>
        </ThemeProvider>
    );
}

export default App;
